import React, { useContext } from 'react';
import AccordionItem from '../AccordionItem/AccordionItem';
import { AstuteAccordionDescription } from '../AccordionItem/astute-accordion-description';
import { useAnalytics } from '../../../hooks/use-analytics';
import { BrandUtil } from '../../../components/utils/brand-util/brand-util';
import ServerContext from '../../../contexts/serverContext';

interface Props {
    topic: string;
    accordions: Element[];
    eventName?: string;
    category?: string;
    subcategory?: string;
    topicId?: string;
}

export const accordionQuery = () => {
    const accordionsSearch = document.querySelectorAll('.accordion');
    const accordionsArray: Element[] = [];
    accordionsSearch &&
        accordionsSearch.forEach(acc => {
            accordionsArray.push(acc);
        });
    return accordionsArray;
};

const AstuteAccordion = (props: Props): React.JSX.Element => {
    const {
        topic,
        accordions,
        eventName,
        category,
        subcategory,
        topicId,
    } = props;
    const [fireEvents] = useAnalytics();
    const serverContext = useContext(ServerContext);
    const { isFord } = new BrandUtil();
    const langReg: string = serverContext.currentLanguageRegionCode || '';

    const findAccordionItems = (accordion: Element, hTag: string) => {
        const titles = Array.from(accordion.querySelectorAll(hTag));
        const descriptions = titles.map(title => {
            return title.nextElementSibling;
        });
        return { titles, descriptions };
    };

    const addAnalyticsForPdfDownload = (html: string) => {
        if (
            isFord &&
            langReg.toLowerCase() === 'en-us' &&
            topicId === '1032283722'
        ) {
            const splites = html?.split(
                `<p>These same steps can be found in this <a href="https://www.globalowneraem.ford.com/content/dam/global-owner/ford/us/en-us/documents/stolen-vehicles-services/SVS_VehicleRecoveryChecklist_v122.pdf" target="_blank"><u>vehicle recovery checklist PDF</u></a> if you’d like to print it out and take notes.</p>`
            );

            return splites && splites.length > 1 ? (
                <div className="article-recovery-pdf">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: splites[0],
                        }}
                    />

                    <p>
                        {'These same steps can be found in this '}
                        <a
                            href="https://www.globalowneraem.ford.com/content/dam/global-owner/ford/us/en-us/documents/stolen-vehicles-services/SVS_VehicleRecoveryChecklist_v122.pdf"
                            onClick={() =>
                                fireEvents(
                                    'astute-pdf-download-onclick',
                                    undefined,
                                    {
                                        fieldName:
                                            'vehicle recovery checklist PDF',
                                    },
                                    false
                                )
                            }
                            target="_blank"
                            rel="noreferrer"
                        >
                            <u>vehicle recovery checklist PDF</u>
                        </a>
                        {' if you’d like to print it out and take notes.'}
                    </p>

                    <div
                        dangerouslySetInnerHTML={{
                            __html: splites[1],
                        }}
                    />
                </div>
            ) : (
                <div
                    dangerouslySetInnerHTML={{
                        __html: html,
                    }}
                />
            );
        } else {
            return (
                <div
                    dangerouslySetInnerHTML={{
                        __html: html,
                    }}
                />
            );
        }
    };
    const buildAccordion = (accordion: Element, hTag: string) => {
        if (accordion) {
            const { titles, descriptions } = findAccordionItems(
                accordion,
                hTag
            );
            return (
                <>
                    <div>
                        {titles.map((title, key) => {
                            const nests = descriptions[key]?.querySelectorAll(
                                '.accordion'
                            );
                            const tagFilter = hTag === 'h4' ? 'h4' : 'h3';

                            if (
                                titles[key].tagName.toLocaleLowerCase() ===
                                    tagFilter &&
                                title.textContent
                            ) {
                                return (
                                    <AccordionItem
                                        title={title.textContent}
                                        titleHTML={title.innerHTML}
                                        key={title.textContent}
                                        eventName={eventName}
                                        category={category}
                                        subcategory={subcategory}
                                    >
                                        {nests && nests.length > 0 ? (
                                            <>
                                                <AstuteAccordionDescription
                                                    descriptions={descriptions}
                                                    indexNumber={key}
                                                    nests={nests}
                                                    descriptionsInnerHtml={0}
                                                />

                                                {buildAccordion(nests[0], 'h4')}

                                                <AstuteAccordionDescription
                                                    descriptions={descriptions}
                                                    indexNumber={key}
                                                    nests={nests}
                                                    descriptionsInnerHtml={1}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                {addAnalyticsForPdfDownload(
                                                    descriptions[key]
                                                        ?.innerHTML || ''
                                                )}
                                            </>
                                        )}
                                    </AccordionItem>
                                );
                            } else return <></>;
                        })}
                    </div>
                </>
            );
        }
    };
    if (accordions.length > 0) {
        const accordion = accordions.shift();
        const astuteSplit = accordion && topic?.split(accordion.outerHTML);

        return (
            <>
                {astuteSplit && astuteSplit.length > 1 && (
                    <>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: astuteSplit[0],
                            }}
                        />
                        {accordion && buildAccordion(accordion, 'h3, h4')}
                        {
                            <AstuteAccordion
                                topic={astuteSplit[1]}
                                accordions={accordions}
                                eventName={eventName}
                                category={category}
                                subcategory={subcategory}
                                topicId={topicId}
                            />
                        }
                    </>
                )}
            </>
        );
    } else {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: topic,
                }}
            />
        );
    }
};
export default AstuteAccordion;
